import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Api from '../../../api';
import { useContent, useLoading } from '../../../hooks/customHooks';
import Brand from '../../../components/Brand';
import PageSlug from '../../../components/PageSlug';
import Footer from '../../../components/Footer';

const PAGE_STATUS = {
    LOADING: 'loading',
    VALID: 'valid',
    CLAIMING: 'claiming',
    EXPIRED: 'expired',
    NOT_FOUND: 'not_found',
    ALREADY_CLAIMED: 'already_claimed',
    ERROR: 'error',
};

export default function ClaimPage() {
    const { content } = useContent();
    const navigate = useNavigate();
    const g = content?.global_settings?.images;

    const { token } = useParams();
    const { setLoading } = useLoading();
    const [pageStatus, setPageStatus] = useState(PAGE_STATUS.LOADING);

    useEffect(() => {
        if (!token) {
            setPageStatus(PAGE_STATUS.NOT_FOUND);
            setLoading(false);
            return;
        }
        (async () => {
            const response = await Api.getIntegrationSession(token);
            if (response?.result && response?.data) {
                const { scaleUserId, selectDifferentVenueUrl, callbackUrl } = response?.data;
                if (scaleUserId) {
                    navigate(`/location-check/${scaleUserId}/email`, {
                        state: {
                            token,
                            selectDifferentVenueUrl,
                            callbackUrl,
                        },
                    });
                }
                setPageStatus(PAGE_STATUS.VALID);
            } else {
                const error = (response?.error || '').toLowerCase();
                if (error.includes('expired')) {
                    setPageStatus(PAGE_STATUS.EXPIRED);
                } else if (error.includes('already') || error.includes('claimed')) {
                    setPageStatus(PAGE_STATUS.ALREADY_CLAIMED);
                } else {
                    setPageStatus(PAGE_STATUS.NOT_FOUND);
                }
            }
            setLoading(false);
        })();
    }, [token]);

    const renderContent = () => {
        if (pageStatus === PAGE_STATUS.LOADING || pageStatus === PAGE_STATUS.CLAIMING) {
            return (
                <PageSlug
                    subtitle={
                        pageStatus === PAGE_STATUS.CLAIMING
                            ? 'Claiming your voucher...'
                            : 'Validating your session...'
                    }
                />
            );
        }

        if (pageStatus === PAGE_STATUS.EXPIRED) {
            return (
                <PageSlug title="Session Expired">
                    <p>
                        This voucher link has expired. Please request a new link from the service
                        provider.
                    </p>
                </PageSlug>
            );
        }

        if (pageStatus === PAGE_STATUS.ALREADY_CLAIMED) {
            return (
                <PageSlug title="Already Claimed">
                    <p>This voucher has already been claimed.</p>
                </PageSlug>
            );
        }

        if (pageStatus === PAGE_STATUS.NOT_FOUND || pageStatus === PAGE_STATUS.ERROR) {
            return (
                <PageSlug title="Invalid Link">
                    <p>
                        This voucher link is invalid or no longer available. Please contact the
                        service provider.
                    </p>
                </PageSlug>
            );
        }

        return (
            <div className={`loading-wrapper`}>
                <div className="loading-spinner" />
            </div>
        );
    };

    return (
        <div className={`${g?.bg ? 'has-bg' : ''} page-wrapper signUpPage`}>
            {g?.bg && (
                <div
                    className={`${g?.bg ? 'with-bg' : ''}`}
                    style={{ backgroundImage: g?.bg && `url(${g?.bg})` }}
                ></div>
            )}
            {g?.header && <Brand image={g?.header} />}

            <main>
                {g?.logo && (
                    <section className="campaign-logo">
                        <img className="header-title-image" alt="scale" src={g?.logo} />
                    </section>
                )}

                <section className={`main-content ${g?.bg ? 'transparent-container' : ''}`}>
                    {renderContent()}
                </section>

                <Footer className={`${g?.bg ? 'transparent-container' : ''}`} />
            </main>
        </div>
    );
}
